import { Grid } from '@material-ui/core';
import { QRBarcodeImage } from './QRBarcodeImage';
import { BarcodeImage } from './BarcodeImage';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { JanBarcodeImage } from './JanBarcodeImage';
var useStyles = makeStyles(function (theme) { return ({
    section: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}); });
export var StaticBarcodes = function (props) {
    var _a;
    var classes = useStyles();
    var staticBarcodes = (_a = props.staticBarcodes) === null || _a === void 0 ? void 0 : _a.map(function (barcode) {
        switch (barcode.barcodeType) {
            case 'qr':
                return (React.createElement(Grid, { item: true, xs: 12, key: barcode.barcode, className: classes.section },
                    React.createElement(QRBarcodeImage, { barcodeType: barcode.barcodeType, barcodeValue: barcode.barcode, imageServer: props.imageServer, size: "10" })));
            case 'nw7':
            case 'code128':
                return (React.createElement(Grid, { item: true, xs: 12, key: barcode.barcode, className: classes.section },
                    React.createElement(BarcodeImage, { barcodeType: barcode.barcodeType, barcodeValue: barcode.barcode, imageServer: props.imageServer })));
            case 'jan13':
            case 'jan8':
                return (React.createElement(Grid, { item: true, xs: 12, key: barcode.barcode, className: classes.section },
                    React.createElement(JanBarcodeImage, { barcodeType: barcode.barcodeType, barcodeValue: barcode.barcode, imageServer: props.imageServer })));
        }
    });
    return React.createElement(React.Fragment, null, staticBarcodes);
};
//# sourceMappingURL=StaticBarcodes.js.map